import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4087e6a7&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4087e6a7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4087e6a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4087e6a7')) {
      api.createRecord('4087e6a7', component.options)
    } else {
      api.reload('4087e6a7', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4087e6a7&scoped=true", function () {
      api.rerender('4087e6a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/overview/index.vue"
export default component.exports